<template>
  <div>
    <el-form
      ref="ruleForm"
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div style="display:flex">
        <el-form-item
          label="平台"
          prop="type"
        >
          <el-select
            v-model="ruleForm.type"
            placeholder="请选择"
            :disabled="onlytype === 1"
          >
            <el-option
              v-for="item in states"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="来源路径"
          prop="source_path"
        >
          <el-input
            v-model.trim="ruleForm.source_path"
            :disabled="isDisabled"
            placeholder="请输入来源路径"
            @blur="link"
          />
        </el-form-item>
      </div>
      <div style="display:flex">
        <el-form-item
          label="视频标题"
          prop="video_title"
        >
          <el-input
            v-model="ruleForm.video_title"
            type="textarea"
            style="width: 500px;"
            :rows="2"
            placeholder="请输入标题"
          />
        </el-form-item>
      </div>
      <div style="display:flex">
        <el-form-item
          label="备份视频地址"
          prop="backup_url"
        >
          <el-input
            v-model="ruleForm.backup_url"
            type="textarea"
            style="width: 500px;"
            :rows="2"
            placeholder="请输入"
          />
        </el-form-item>
      </div>
      <div style="display:flex">
        <!-- <el-form-item
          label="视频别名"
          prop="alias_name"
        >
          <el-input
            v-model="ruleForm.alias_name"
            placeholder="请输入别名"
          />
        </el-form-item> -->
        <el-form-item
          label="虚拟点赞数"
          prop="virtual_likes"
        >
          <el-input
            v-model="ruleForm.virtual_likes"
            v-numberOnly
            max="999999"
          />
        </el-form-item>
        <el-form-item
          label="虚拟热度"
          prop="virtual_heat"
        >
          <el-input
            v-model="ruleForm.virtual_heat"
            v-numberOnly
            max="999999"
          />
        </el-form-item>
      </div>
      <div style="display:flex">
        <el-form-item
          label="视频分类"
          prop="video_type"
        >
          <!-- <el-select
            v-model="ruleForm.video_type"
            placeholder="请选择"
          >
            <el-option
              label="推荐"
              value="1"
            />
            <el-option
              label="娱乐"
              value="2"
            />
            <el-option
              label="搞笑"
              value="3"
            />
            <el-option
              label="生活"
              value="4"
            />
          </el-select> -->
          <el-select
            v-model="ruleForm.video_type"
            placeholder="请选择"
          >
            <el-option
              v-for="item in cateoptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <!-- <div>
        <el-form-item
          label="后台筛选类目"
          prop="screen_category"
        >
          <el-select
            v-model="ruleForm.screen_category"
            placeholder="请选择"
          >
            <el-option
              label="社会新闻"
              :value="1"
            />
            <el-option
              label="搞笑"
              :value="2"
            />
            <el-option
              label="养生"
              :value="3"
            />
            <el-option
              label="电影"
              :value="4"
            />
            <el-option
              label="祝福"
              :value="5"
            />
            <el-option
              label="美女"
              :value="6"
            />
            <el-option
              label="技术测试"
              :value="7"
            />
          </el-select>
        </el-form-item>
      </div> -->
      <!-- <div style="display:flex">
        <el-form-item
          label="选择小程序"
          prop="app_ids"
        >
          <el-button
            style="margin-right:10px"
            type="primary"
            size="mini"
            @click="chooseidsr"
          >选择小程序</el-button>
          <div style="max-height: 50px; overflow-y: auto;display: inline-block;vertical-align: top;">
            <span
              v-for="item,index in ruleForm.app_ids"
              :key="index"
            >
              <el-tag
                v-if="item.sign"
                style="margin-right:10px"
                @close="handleClose(item,index)"
              >{{ item.account_name }}</el-tag>
              <el-tag
                v-else
                closable
                style="margin-right:10px"
                @close="handleClose(item,index)"
              >{{ item.account_name }}</el-tag>
            </span>
          </div>
        </el-form-item>

      </div> -->
      <div style="display:flex">
        <el-form-item
          label="封面地址"
          prop="cover_path"
        >
          <!-- <el-input
            v-model="ruleForm.cover_path"
            type="textarea"
            :rows="2"
            placeholder="请输入"
          /> -->
          <div>
            <img
              v-if="ruleForm.cover_path"
              style="height: 120px; width: 120px;"
              :src="ruleForm.cover_path"
            >
          </div>
          <!-- <el-button
            type="primary"
            size="mini"
            @click="$refs.filerr.click()"
          >上传封面<input
              ref="filerr"
              style="display:none;"
              type="file"
              multiple
              accept="image/gif,image/jpg,image/jpeg,image/png"
              @change="uploadPicturesr"
            ></el-button> -->
          <el-button
            type="primary"
            size="mini"
            @click="chooseimgclickr"
          >上传封面</el-button>
        </el-form-item>

        <el-form-item
          label="视频地址"
          prop="video_path"
        >
          <!-- <el-input
            v-model="ruleForm.video_path"
            type="textarea"
            :rows="2"
            placeholder="请输入"
          /> -->
          <div v-if="ruleForm.cover_path">
            <a
              href="javascript:void(0);"
              onclick="test()"
              class="video-link"
              @click="(showModal = true),(selectedVideoUrl = ruleForm.video_path)"
            >
              <el-image
                v-if="ruleForm.cover_path"
                style="height: 120px; width: 120px;"
                :src="ruleForm.cover_path"
                fit="cover"
                :lazy="true"
              />
              <span
                class="play-button"
                style="position: absolute; top: 50%; left: 50%;font-size:80px;color:#ccc; transform: translate(-50%, -50%);"
              >
                <i class="el-icon-caret-right" />
              </span>
            </a>
          </div>
        </el-form-item>
      </div>
      <!-- <div style="display:flex">
        <el-form-item
          prop="publish_status"
          label="发布状态"
        >
          <el-radio-group v-model="ruleForm.publish_status">
            <el-radio-button :label="1">发布</el-radio-button>
            <el-radio-button :label="2">待发布</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </div> -->
      <div style="display:flex">
        <el-form-item
          label="小程序视频是否开启激励广告"
          label-width="200px"
        >
          <el-switch
            v-model="open_encourage"
            :inactive-value="1"
            :active-value="2"
            active-color="#13ce66"
            inactive-color="rgb(191,191,191)"
            :active-text="open_encourage == 1 ? '关闭' : ''"
            :inactive-text="open_encourage == 2 ? '开启' : ''"
          />
        </el-form-item>
      </div>
      <div style="display:flex">
        <el-form-item
          label="小程序视频是否开启视频广告"
          label-width="200px"
        >
          <el-switch
            v-model="open_video_ad"
            :inactive-value="1"
            :active-value="2"
            active-color="#13ce66"
            inactive-color="rgb(191,191,191)"
            :active-text="open_video_ad == 1 ? '关闭' : ''"
            :inactive-text="open_video_ad == 2 ? '开启' : ''"
          />
        </el-form-item>
      </div>
      <div style="display:flex">
        <el-form-item
          label="小程序视频是否开启游戏"
          label-width="200px"
        >
          <el-switch
            v-model="pop_game"
            :inactive-value="2"
            :active-value="1"
            active-color="#13ce66"
            inactive-color="rgb(191,191,191)"
            :active-text="pop_game == 1 ? ' 开启' : ''"
            :inactive-text="pop_game == 2 ? '关闭' : ''"
          />
        </el-form-item>
      </div>
      <!-- <div style="display:flex">
        <el-form-item
          label="广告配置开关"
          prop="ad_configuration"
          label-width="100px"
        >
          <el-switch
            v-model="ruleForm.ad_configuration"
            :inactive-value="1"
            :active-value="2"
            active-color="#13ce66"
            inactive-color="rgb(191,191,191)"
            :active-text="ruleForm.ad_configuration == 1 ? '关闭' : ''"
            :inactive-text="ruleForm.ad_configuration == 2 ? '开启' : ''"
            @change="changewr"
          />
        </el-form-item>
      </div> -->
      <!-- <div>
        <el-form-item v-if="ruleForm.ad_configuration==2">
          <div>
            <el-checkbox
              v-model="ad_setting.encourage_ad"
              style="margin-right: 50px;"
              :disabled="ad_setting.video_patch_ad||ad_setting.insert_screen_ad"
              @change="changeencourage_ad"
            >激励</el-checkbox>
            <el-radio-group v-model="encourage_ad">
              <el-radio
                :disabled="!ad_setting.encourage_ad"
                :label="1"
              >1s</el-radio>
              <el-radio
                :disabled="!ad_setting.encourage_ad"
                :label="10"
              >10s</el-radio>
              <el-radio
                :disabled="!ad_setting.encourage_ad"
                :label="20"
              >20s</el-radio>
              <el-radio
                :disabled="!ad_setting.encourage_ad"
                :label="60"
              >60s</el-radio>
            </el-radio-group>
          </div>
          <div>
            <el-checkbox
              v-model="ad_setting.insert_screen_ad"
              :disabled="ad_setting.video_patch_ad||ad_setting.encourage_ad"
              style="margin-right: 50px;"
            >插屏</el-checkbox>
          </div>
          <div>
            <el-checkbox
              v-model="ad_setting.video_patch_ad"
              :disabled="ad_setting.insert_screen_ad||ad_setting.encourage_ad"
              style="margin-right: 23px;"
            >视频贴片</el-checkbox>
          </div>
        </el-form-item>

      </div> -->

      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <!-- 加载进度条的样式 -->
    <div
      v-if="showProgress"
      class="bacc"
    >
      <div class="jindutiao">
        <el-progress
          type="circle"
          :percentage="percentage"
          :width="80"
          class="progressCircle"
        />
      </div>
    </div>
    <div
      v-if="showModal"
      class="modal"
      @click="closeModal"
    >
      <div class="modal-content">
        <video
          ref="videoPlayer"
          :src="selectedVideoUrl"
          controls
          autoplay
          @click="playVideo"
        />
      </div>
    </div>
    <el-dialog
      title="选择小程序"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="60%"
    >
      <bandstaff
        ref="bandstaffview"
        @bandarr="bandarr"
      />
    </el-dialog>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
  </div>
</template>
<script>
import bandstaff from '../../appLookVideo/components/bandstaff.vue'
import { newMaterial } from '@/api/sourceMaterial.js'
// import * as qiniu from 'qiniu-js'
// import { qiniuToken } from '@/api/qiniuToken.js'
import getNowDate from '@/utils/mixins/convertToHump.js'

import { thirdVideoSearch } from '@/api/sourceMaterial.js'
import chooseimg from '../../menumanagement/components/TencentCloudChooseimg.vue'
import { videoCategorylist, videoSettinghandStore, videoSettingupdateVideo } from '@/api/sourceminiprogram.js'
export default {
  components: {
    bandstaff,
    chooseimg
  },
  directives: {
    numberOnly: {
      bind(el) {
        el.addEventListener('input', function (event) {
          const input = event.target
          let value = input.value
          value = value.replace(/\D/g, '') // 只保留数字

          if (value.length > 6) {
            value = value.slice(0, 6) // 截取前4位数字
          }

          input.value = value
        })
      }
    }
  },
  mixins: [getNowDate],
  data() {
    return {
      time: '',
      showProgress: false,
      percentage: 0,
      ruleForm: {
        video_title: null, // 视频标题
        alias_name: null, // 视频别名
        virtual_likes: null, // 虚拟点赞数
        virtual_heat: null, // 虚拟热度
        ad_configuration: 2, // 广告配置开关 1.关闭 2.开启 当广告配置开启时才会出现广告类型和广告弹出↓
        type: null, // 视频平台：1.抖音 2.快手
        // ad_type: 1, // 广告类型 1激励 2插屏
        // ad_ball_time: '1', // 广告在视频第几秒弹出 单位秒 给选项点击 0s 10s 20s 60s
        app_ids: [],
        video_type: null,
        video_path: null,
        cover_path: null,
        source_path: null,
        backup_url: null,
        publish_status: 1,
        screen_category: 1
      },
      open_encourage: 2,
      open_video_ad: 2,
      pop_game: 2,
      rules: {
        source_path: [{ required: true, message: '请输入来源路径', trigger: 'blur' }],
        video_type: [{ required: true, message: '请选择视频分类', trigger: 'blur' }],
        video_title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        alias_name: [{ required: true, message: '请输入别名', trigger: 'blur' }],
        type: [{ required: true, message: '请选择平台', trigger: 'blur' }],
        'ad_setting.encourage_ad': [{ required: true, message: '', trigger: 'blur' }]
      },
      loading: false,
      states: [
        { id: 1, value: '抖音' },
        { id: 2, value: '快手' }
      ],
      adstates: [
        { id: 1, value: '激励' },
        { id: 2, value: '插屏' }
      ],
      tableData: {
        list: [],
        total: 10
      },
      dialogVisible: false,
      dialogVisibler: false,
      initarr: [],
      token: null, // 七牛云token
      encourage_ad: '',
      ad_setting: {
        encourage_ad: false,
        insert_screen_ad: false,
        video_patch_ad: false
      },
      showModal: false,
      selectedVideoUrl: '',
      onlytype: '',
      source_path: '',
      dialogVisibletwo: false,
      cateoptions: [],
      all_id: null,
      all_type: null
    }
  },
  computed: {
    isDisabled() {
      return this.ruleForm.type === null || this.onlytype === 1
    }
  },
  created() {
    // this.reset()
    // this.getQiniuToken()
  },
  // 页面初始化挂载dom
  mounted() {},
  methods: {
    changeencourage_ad(e) {
      console.log('e:', e)
      if (e) {
        this.encourage_ad = 1
      } else {
        this.encourage_ad = ''
      }
    },
    closeModal() {
      this.showModal = false
      this.selectedVideoUrl = ''
      this.$refs.videoPlayer.pause()
    },
    // async getQiniuToken() {
    //   const data = await qiniuToken()
    //   this.token = data.data.upToken
    // },
    async uploadPicturesr(e) {
      const fileIfon = e.target.files[0]
      const img = new Image()
      const video_path = window.URL.createObjectURL(fileIfon)
      img.src = video_path
      // this.ruleForm.video_path = ruleForm.video_path
      console.log('小程序')
      const options = {
        quality: 0.62,
        noCompressIfLarger: false,
        maxWidth: 1000,
        maxHeight: 1000
      }
      const ftype = fileIfon.name.substr(fileIfon.name.lastIndexOf('.')) // 截取文件格式
      const extension = ftype === '.jpg'
      const extension2 = ftype === '.png'
      const extension3 = ftype === '.jpeg'
      const extension4 = ftype === '.gif'
      // eslint-disable-next-line eqeqeq
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: '请上传正确的上传格式(jpg, png, jpeg, gif)',
          type: 'error'
        })
        return
      }
      if (ftype !== '.gif') {
        qiniu.compressImage(fileIfon, options).then(data => {
          const observable = qiniu.upload(
            data.dist,
            `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
            this.token,
            {
              fname: fileIfon.name // 文件名
            },
            {
              useCdnDomain: true // cdn域名加速
            }
          )
          observable.subscribe({
            next() {},
            error(err) {
              console.log(err)
            },
            complete: data => {
              newMaterial({
                type: 1,
                height: img.height,
                width: img.width,
                size: fileIfon.size,
                key: data.key
              }).then(res => {
                console.log('res', res)
                this.ruleForm.cover_path = res.data.path
                this.formLabelAlign.sourceMaterialId = res.data.sourceMaterialId
                this.$message({
                  message: '上传成功',
                  type: 'success'
                })
              })
            }
          })
        })
      } else {
        const observable = qiniu.upload(
          fileIfon,
          `user/${Math.random().toString(36).slice(-6) + '-' + this.getNowDate() + ftype}`,
          this.token,
          {
            fname: fileIfon.name // 文件名
          },
          {
            useCdnDomain: true // cdn域名加速
          }
        )
        observable.subscribe({
          next() {},
          error(err) {
            console.log(err)
          },
          complete: data => {
            newMaterial({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: data.key
            }).then(res => {
              console.log('res', res)
              this.ruleForm.video_path = res.data.path
              this.formLabelAlign.sourceMaterialId = res.data.sourceMaterialId
              this.$message({
                message: '上传成功',
                type: 'success'
              })
            })
          }
        })
      }
    },
    playVideo() {
      const videoPlayer = this.$refs.videoPlayer
      if (videoPlayer.paused) {
        videoPlayer.play()
      } else {
        videoPlayer.pause()
        this.selectedVideoUrl = ''
      }
    },
    async link() {
      if (this.ruleForm.source_path !== null) {
        const res = await thirdVideoSearch({
          source_path: this.ruleForm.source_path,
          from_type: this.ruleForm.type
        })
        console.log(res.data)
        this.ruleForm.video_title = res.data.video_title
        this.ruleForm.video_path = res.data.video_path
        this.ruleForm.cover_path = res.data.cover_path
        this.source_path = res.data.source_path
      }
    },
    async bandarr(arrs) {
      console.log('this.initarr:', this.inistarr)
      if (this.initarr === undefined) {
        this.initarr = []
      }
      // if (this.initarr.length !== 0) {
      //   this.initarr.forEach(item => {
      //     console.log('item:', item)
      //     arrs.forEach(v => {
      //       console.log('v:', v)
      //       if (item.app_id !== v.app_id) {
      //         this.ruleForm.app_ids = []
      //         this.ruleForm.app_ids.push(item)
      //         this.ruleForm.app_ids.push(v)
      //       }
      //     })
      //   })
      // } else {
      this.ruleForm.app_ids = arrs
      // }
      console.log('this.ruleForm.app_ids:', this.ruleForm.app_ids)
      this.dialogVisibler = false
    },
    handleClose(item, index) {
      this.ruleForm.app_ids.splice(index, 1)
    },
    chooseidsr() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        console.log('this.ruleForm.id:', this.ruleForm.id)
        this.$refs.bandstaffview.sendr(this.ruleForm.app_ids, this.ruleForm.id)
      })
    },
    sendr(row, type, arr, cover_path) {
      this.classificationlist()
      console.log('row:', row)
      if (row === undefined) {
        console.log('新增')
        this.all_type = 1
        this.ruleForm.virtual_likes = Math.floor(Math.random() * 9000) + 1000 // 虚拟点赞数
        this.ruleForm.virtual_heat = Math.floor(Math.random() * 9000) + 1000 // 虚拟热度
      } else {
        this.all_type = 2
        this.all_id = row.id
        console.log('编辑')
        this.ruleForm.type = row.platform
        this.ruleForm.source_path = row.source_path
        this.ruleForm.video_title = row.title
        this.ruleForm.video_type = row.category_id
        this.ruleForm.video_path = row.video_url
        this.ruleForm.cover_path = row.video_cover
        this.open_encourage = row.open_encourage
        this.open_video_ad = row.open_video_ad
        this.pop_game = row.pop_game
        this.ruleForm.backup_url = row.backup_url
        this.ruleForm.virtual_likes = row.virtual_likes
        this.ruleForm.virtual_heat = row.virtual_heat
      }
      // if (row === undefined) {
      //   this.ruleForm = {
      //     type: null, // 视频平台：1.抖音 2.快手
      //     video_title: null, // 视频标题
      //     alias_name: null, // 视频别名
      //     virtual_likes: Math.floor(Math.random() * 9000) + 1000, // 虚拟点赞数
      //     virtual_heat: Math.floor(Math.random() * 9000) + 1000, // 虚拟热度
      //     ad_configuration: 2, // 广告配置开关 1.关闭 2.开启 当广告配置开
      //     app_ids: [],
      //     video_type: null,
      //     video_path: null,
      //     cover_path: null,
      //     source_path: null,
      //     open_encourage: 2,
      //     backup_url: null,
      //     publish_status: 1,
      //     screen_category: 1
      //   }
      //   return
      // }
      // const item = JSON.parse(JSON.stringify(row))
      // console.log('item', item)
      // this.onlytype = 1
      // item.ad_ball_time = item.ad_ball_time + ''
      // item.video_type = item.video_type
      // // console.log('item.ad_configuration:', item.ad_configuration)
      // // if (item.applet_info && item.applet_info.length > 0) {
      // let aa = false
      // if (row.applet_info && row.applet_info.length !== 0 && type !== 999) {
      //   console.log(4)
      //   item.app_ids = item.applet_info
      //     .filter(v => v.app_id !== null)
      //     .map(v => {
      //       console.log('v:', v)
      //       return {
      //         account_name: v.account_name,
      //         app_id: v.app_id,
      //         sign: true
      //       }
      //     })
      //   aa = true
      // }
      // if (typeof item.applet_info === 'string') {
      //   console.log(9999)
      //   this.initarr = []
      // } else if (item.applet_info.length !== 0) {
      //   this.initarr = item.app_ids

      //   item.app_ids = aa ? item.app_ids : item.applet_info
      // } else {
      //   this.initarr = []
      //   item.app_ids = aa ? item.app_ids : item.applet_info
      // }
      // this.ruleForm = item
      // this.ruleForm.video_title = item.name
      // if (typeof item.ad_setting === 'object' && item.ad_setting !== null && type !== 999) {
      //   for (const key in item.ad_setting) {
      //     if (item.ad_setting[key] === false) {
      //       // eslint-disable-next-line eqeqeq
      //       if (this.ruleForm.ad_configuration == 2) {
      //         console.log(55)
      //       }
      //     } else {
      //       console.log('key:', key)
      //       if (key === 'encourage_ad') {
      //         this.ad_setting = {
      //           [key]: true
      //         }
      //         this.encourage_ad = item.ad_setting.encourage_ad.ad_ball_time
      //       } else {
      //         this.ad_setting = {
      //           ...this.ad_setting,
      //           [key]: true
      //         }
      //       }
      //     }
      //   }
      // } else {
      //   this.ad_setting = {
      //     encourage_ad: false,
      //     insert_screen_ad: false,
      //     video_patch_ad: false
      //   }
      // }
      // if (type === 999) {
      //   this.ruleForm.app_ids = arr
      //   this.ruleForm.video_title = item.video_title
      //   this.ruleForm.source_path = cover_path
      // }
      // console.log('this.ruleForm:', this.ruleForm)
      // console.log('this.initarr:', this.initarr)
    },
    isSixDigitNumber(num) {
      return /^\d{0,6}$/.test(num)
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.all_type === 1) {
            videoSettinghandStore({
              platform: this.ruleForm.type,
              source_path: this.ruleForm.source_path,
              title: this.ruleForm.video_title,
              category_id: this.ruleForm.video_type,
              video_url: this.ruleForm.video_path,
              video_cover: this.ruleForm.cover_path,
              open_encourage: this.open_encourage,
              open_video_ad: this.open_video_ad,
              pop_game: this.pop_game,
              backup_url: this.ruleForm.backup_url,
              virtual_likes: this.ruleForm.virtual_likes, // 虚拟点赞数
              virtual_heat: this.ruleForm.virtual_heat // 虚拟热度
            }).then(res => {
              console.log('res', res)
              this.$emit('determine')
            })
          } else {
            videoSettingupdateVideo({
              platform: this.ruleForm.type,
              source_path: this.ruleForm.source_path,
              title: this.ruleForm.video_title,
              category_id: this.ruleForm.video_type,
              video_url: this.ruleForm.video_path,
              video_cover: this.ruleForm.cover_path,
              open_encourage: this.open_encourage,
              open_video_ad: this.open_video_ad,
              pop_game: this.pop_game,
              backup_url: this.ruleForm.backup_url,
              virtual_likes: this.ruleForm.virtual_likes, // 虚拟点赞数
              virtual_heat: this.ruleForm.virtual_heat, // 虚拟热度
              id: this.all_id
            }).then(res => {
              console.log('res', res)
              this.$emit('determine')
            })
          }

          // console.log('this.ruleForm.app_ids:', this.ruleForm)
          // if (this.ruleForm.app_ids.length === 0) return this.$message('请选择小程序')
          // const arr = this.ruleForm.app_ids
          // if (this.ruleForm.app_ids.length !== 0) {
          //   this.ruleForm.app_ids = this.ruleForm.app_ids.map(v => v.app_id)
          // }
          // // eslint-disable-next-line eqeqeq
          // if (this.ruleForm.ad_configuration == 1) {
          //   this.ruleForm.ad_setting = {}
          // }
          // // eslint-disable-next-line eqeqeq
          // if (this.ruleFormcover_path == '') {
          //   return this.$message('请选择图片')
          // }
          // let isSixDigit = false
          // isSixDigit = this.isSixDigitNumber(this.ruleForm.virtual_likes)
          // isSixDigit = this.isSixDigitNumber(this.ruleForm.virtual_heat)
          // console.log(isSixDigit) // true
          // if (!isSixDigit) {
          //   return this.$message('虚拟热度和点赞数最大6位数')
          // }
          // if (this.ruleForm.id) {
          //   const { id, type, alias_name, virtual_likes, virtual_heat, ad_configuration, ad_setting, video_type, app_ids, cover_path, video_title, publish_status, source_path, open_encourage, backup_url, screen_category } = this.ruleForm
          //   this.ruleForm = {
          //     id,
          //     type,
          //     alias_name,
          //     virtual_likes,
          //     virtual_heat,
          //     publish_status,
          //     ad_configuration,
          //     app_ids,
          //     video_type,
          //     cover_path,
          //     ad_setting,
          //     video_title,
          //     source_path,
          //     open_encourage,
          //     backup_url,
          //     screen_category
          //   }
          // }
          // this.ruleForm.type = parseInt(this.ruleForm.type)
          // this.ruleForm.ad_configuration = parseInt(this.ruleForm.ad_configuration)
          // console.log(11, this.ruleForm)
          // this.$emit('determine', this.ruleForm, arr, this.source_path)
          // // this.reset()
          // if (this.$refs.form !== undefined) {
          //   this.$refs.form.resetFields()
          // }
        }
      })
    },

    async changewr(val) {
      console.log('val:', val)
      this.ruleForm.ad_configuration = val
    },
    async changewr2(val) {
      console.log('val:', val)
      this.ruleForm.open_encourage = val
    },
    getLoadEcharts(data) {
      var myChart = this.$echarts.init(document.getElementById('echart'))
      console.log('datas', data)
      // this.fileList = data.map(item => {
      //   return { item.count }
      // })
      for (let i = 0; i < data.length; i++) {
        this.arr.push(data[i].count)
      }
      for (let i = 0; i < data.length; i++) {
        this.arrs.push(data[i].date)
      }
      console.log('this.arr', this.arr)
      var option = {
        color: '#96d2e9', // 设定实线点的颜色
        title: {
          // text: 'Stacked Line'
        },
        minInterval: 1,
        tooltip: {
          trigger: 'axis'
        },

        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.arrs
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            // name: 'Email',
            type: 'line',
            stack: 'Total',
            data: this.arr
          }
        ]
      }
      myChart.setOption(option)
    },
    // 重置
    reset() {
      this.ruleForm = {
        type: null, // 视频平台：1.抖音 2.快手
        source_path: null, // 博主名称
        video_title: null, // 视频标题
        alias_name: null, // 视频别名
        virtual_likes: null, // 虚拟点赞数
        virtual_heat: null, // 虚拟热度
        ad_configuration: 2, // 广告配置开关 1.关闭 2.开启 当广告配置开启时才会出现广告类型和广告弹出↓
        // ad_type: 1, // 广告类型 1激励 2插屏
        // ad_ball_time: '1', // 广告在视频第几秒弹出 单位秒 给选项点击 0s 10s 20s 60s
        app_ids: [],
        video_type: null,
        open_encourage: 2,
        video_path: null,
        cover_path: null,
        backup_url: null
      }
    },
    chooseimgclickr() {
      this.dialogVisibletwo = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    clickicon(img, key) {
      this.dialogVisibletwo = false
      this.ruleForm.cover_path = img
      // this.formLabelAlign.sourceMaterialId = key
      // this.allfrom[this.allfromindex].source_material_id = key
      // this.allfrom[this.allfromindex].source_material_img = img
    },
    async classificationlist() {
      const data = await videoCategorylist({
        page: 1,
        page_size: 100
      })
      this.cateoptions = data.data.list
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 22px;
  margin: 10px;
}
.choose_palte {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.chasew {
  width: 80px;
  text-align: right;
}
.updatabocwr {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 130px;
  height: 130px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
  text-align: center;
}
.updatabocwr i {
  font-size: 28px;
  color: #8c939d;
}
.updatabocwr i:hover {
  border: none;
}
.wrwaw :hover {
  border: 1px dashed #409eff;
}
.updata_casr {
  width: 130px;
  height: 130px;
}
.bacc {
  /*bacc是灰色的大背景*/
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  /*这个类的作用是把进度条放到水平垂直居中的位置*/
}
.jindutiao {
  position: absolute;
  width: 150px;
  height: 150px;
  top: 50%;
  left: 50%;
  margin-left: -75px;
  margin-top: -75px;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-switch__label--right,
::v-deep .el-switch__label--left {
  background-color: #fff !important;
}
.el-select {
  width: 192px;
}
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.modal-content {
  position: relative;
  max-width: 80%;
  max-height: 80%;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>
